module.exports = __webpack_public_path__ + "img/pdgt_fnc.063bc836.jpg";